import {TableHeaderComponent} from './table-header/table-header.component';
import {TableActionComponent} from './table-action/table-action.component';
import {TableComponent} from './table.component'
import {NgModule} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";
import {FormsModule} from '@angular/forms';
import {PaginationModule} from "ngx-bootstrap";
// import {CommonModule as ApplicationCommonModule} from "app/components/common/common.module";
import {CommonModule} from '@angular/common';
import {FileTreeTableComponent} from './file-tree-table/file-tree-table.component';
import {TableSelectComponent} from "./table-select/table-select.component";
import {TableStaticComponent} from "./table-static/table-static.component";
import {AppTranslationModule} from '../../../app.translation.module';
// import {PipesModule} from "../../../pipes/pipes.module";

@NgModule({
    imports: [
        // ApplicationCommonModule,
        TranslateModule, 
        FormsModule, 
        PaginationModule.forRoot(), 
        CommonModule,
        AppTranslationModule
        // PipesModule
    ],
    exports: [TableComponent, TableActionComponent, TableSelectComponent, TableStaticComponent, TableHeaderComponent, FileTreeTableComponent],
    declarations: [TableComponent, TableActionComponent, TableSelectComponent, TableStaticComponent, TableHeaderComponent, FileTreeTableComponent]
})
export class TableModule{

}